import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectVolumeCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.VOLUME_CAPSULE];

export const selectVolumeCapsuleState = (state: State, widgetKey: string) =>
    selectVolumeCapsulesState(state)[widgetKey];
